import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import queryString from 'query-string';
import { toast } from 'react-toastify';

// Loader Components
import showLoader from '@components/loader';

export const getSector = createAsyncThunk('sectorSlice/getSector', async () => {
    try {
        let response = await axios.get('/sector', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getSectorOption = createAsyncThunk('sectorSlice/getSectorOption', async (data) => {
    try {
        showLoader(true);
        const query = queryString.stringify(data);
        let response = await axios.get('/sector/options' + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createSector = createAsyncThunk('sectorSlice/createSector', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.post('/sector', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Sector created successfully.');
        dispatch(getSector());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateSector = createAsyncThunk('sectorSlice/updateSector', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/sector/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Sector updated successfully.');
        dispatch(getSector());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteSector = createAsyncThunk('sectorSlice/deleteSector', async (deleteId, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.delete('/sector/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Sector deleted successfully');
        dispatch(getSector());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateSectorStatus = createAsyncThunk('sectorSlice/updateSectorStatus', async (id, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/sector/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status updated successfully.');
        dispatch(getSector());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.err(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const sectorSlice = createSlice({
    name: 'sectorSlice',
    initialState: {
        data: [],
        option: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getSector.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getSectorOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
    }
});

export default sectorSlice.reducer;
